module.exports = __webpack_public_path__ + "img/ne_logo.27e7244c.svg";